export var STATUS = {
    init: 'init',
    uploading: 'uploading',
    success: 'done',
    fail: 'error',
};
